var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirmwareUpgrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 376,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1927,
    y: 934,
    width: 361,
    height: 376
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2021,
    y: 1135,
    width: 172,
    height: 170
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2021,
    y: 1135,
    width: 172,
    height: 170
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2021,
    y: 1135,
    width: 172,
    height: 170
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1927 -934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1927 1039.87C1927 1021.16 1942.16 1006 1960.87 1006L2253.13 1006C2271.84 1006 2287 1021.16 2287 1039.87L2287 1275.13C2287 1293.84 2271.84 1309 2253.13 1309L1960.87 1309C1942.16 1309 1927 1293.84 1927 1275.13Z",
    fill: "#99D3CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2257.59 1017.03C2267.74 1017.03 2275.98 1025.24 2275.98 1035.38L2275.98 1279.64C2275.98 1289.78 2267.74 1298 2257.59 1298L1956.43 1298C1946.27 1298 1938.04 1289.78 1938.04 1279.64L1938.04 1035.38C1938.04 1025.24 1946.27 1017.03 1956.43 1017.03L2257.59 1017.03M2257.59 1006.01 1956.43 1006.01C1940.18 1006.01 1927.01 1019.16 1927.01 1035.38L1927.01 1279.64C1927.01 1295.86 1940.18 1309.01 1956.43 1309.01L2257.59 1309.01C2273.84 1309.01 2287.01 1295.86 2287.01 1279.64L2287.01 1035.38C2287.01 1019.16 2273.84 1006.01 2257.59 1006.01Z",
    fill: "#99D3CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2055.01 1017.01 2016.01 1017.08 2016.3 1056.01 2055.01 1017.01Z",
    fill: "#F5F6F8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2015.01 1018.01 1955.34 1018.01C1945.61 1019.28 1938.27 1027.31 1938.01 1036.96L1938.45 1094.01Z",
    fill: "#F5F6F8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2074.01 1017.01 2055.01 1017.05 2055.18 1037.01 2074.01 1017.01Z",
    fill: "#F5F6F8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7083 60.2083 30.1041 60.2083 30.1041 67.2916 17.7083 67.2916Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7083 46.0416 30.1041 46.0416 30.1041 53.1249 17.7083 53.1249Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7083 74.3749 30.1041 74.3749 30.1041 81.4582 17.7083 81.4582Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7083 116.875 30.1041 116.875 30.1041 123.958 17.7083 123.958Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7083 102.708 30.1041 102.708 30.1041 109.792 17.7083 109.792Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7083 88.5416 30.1041 88.5416 30.1041 95.6249 17.7083 95.6249Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.896 102.708 152.291 102.708 152.291 109.792 139.896 109.792Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.896 116.875 152.291 116.875 152.291 123.958 139.896 123.958Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.896 88.5416 152.291 88.5416 152.291 95.6249 139.896 95.6249Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.896 46.0416 152.291 46.0416 152.291 53.1249 139.896 53.1249Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.896 74.3749 152.291 74.3749 152.291 81.4582 139.896 81.4582Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.896 60.2083 152.291 60.2083 152.291 67.2916 139.896 67.2916Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5416 17.7083 95.6249 17.7083 95.6249 30.1041 88.5416 30.1041Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.875 17.7083 123.958 17.7083 123.958 30.1041 116.875 30.1041Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.708 17.7083 109.792 17.7083 109.792 30.1041 102.708 30.1041Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3749 17.7083 81.4582 17.7083 81.4582 30.1041 74.3749 30.1041Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0416 17.7083 53.1249 17.7083 53.1249 30.1041 46.0416 30.1041Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2083 17.7083 67.2916 17.7083 67.2916 30.1041 60.2083 30.1041Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2083 139.896 67.2916 139.896 67.2916 152.291 60.2083 152.291Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0416 139.896 53.1249 139.896 53.1249 152.291 46.0416 152.291Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3749 139.896 81.4582 139.896 81.4582 152.291 74.3749 152.291Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5416 139.896 95.6249 139.896 95.6249 152.291 88.5416 152.291Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.708 139.896 109.792 139.896 109.792 152.291 102.708 152.291Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.875 139.896 123.958 139.896 123.958 152.291 116.875 152.291Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9791 61.9791 108.021 61.9791 108.021 108.021 61.9791 108.021Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.729 37.1875 44.2708 37.1875C40.3588 37.1875 37.1875 40.3588 37.1875 44.2708L37.1875 125.729C37.1875 129.641 40.3588 132.812 44.2708 132.812L125.729 132.812C129.641 132.812 132.812 129.641 132.812 125.729L132.812 44.2708C132.812 40.3588 129.641 37.1875 125.729 37.1875ZM115.104 115.104 54.8958 115.104 54.8958 54.8958 115.104 54.8958Z",
    fill: "#6C4BC1",
    transform: "matrix(1 0 0 1 2022 1135)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M2207.5 1027.5 2107.5 1118.5 2007.5 1027.5 2057.5 1027.5 2057.5 936.5 2157.5 936.5 2157.5 1027.5Z",
    stroke: "#6C4BC1",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#6C4BC1",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirmwareUpgrade);
export default __webpack_public_path__ + "static/media/firmware-upgrade.431c206faed4ab64f97715d2a14b7afc.svg";
export { ForwardRef as ReactComponent };